import React, { useState, useEffect } from 'react';

import img2 from './Photos/1976-78.jpg';
import img3 from './Photos/a1.jpg';
import img4 from './Photos/a2.jpg';
import img5 from './Photos/a4.jpg';
import img6 from './Photos/a6.jpg';
import img7 from './Photos/a12.jpg';
import img8 from './Photos/a13.jpg';
import img9 from './Photos/a18.jpg';
import img10 from './Photos/b1.jpg';
import img11 from './Photos/b18.jpg';
import img12 from './Photos/DM 2010-12.jpg';
import img13 from './Photos/Dubai Meet.jpg';
import img14 from './Photos/gr photo(1).jpg';
import img15 from './Photos/gr16.jpg';
import img16 from './Photos/gr17.jpg';
import img17 from './Photos/gr21.jpg';
import img18 from './Photos/gr51.jpg';
import img19 from './Photos/gr80.jpg';
import img20 from './Photos/gr84.jpg';

import img22 from './Photos/IMG_20191204_113746.jpg';
import img23 from './Photos/IMG-20191204-WA0025.jpg';
import img24 from './Photos/pl.jpg';
import img25 from './Photos/pl2.jpg';
import img26 from './Photos/PXL_20230806_080530786.MP.jpg';
import img27 from './Photos/PXL_20230806_084757943.jpg';
import img28 from './Photos/PXL_20230806_095931437.jpg';
import img29 from './Photos/PXL_20230806_101827090.jpg';
import img30 from './Photos/PXL_20230806_104426685.MP.jpg';
import img31 from './Photos/PXL_20230806_112022557.MP.jpg';
import img32 from './Photos/tiss fest.jpg';
import img33 from './Photos/tiss1.jpg';
import Footer from '../Footer';

const Photo = () => {
  const images = [img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13,
    img14, img15, img16, img17, img18, img19, img20,  img22, img23, img24, img25, img26,
    img27, img28, img29, img30, img31, img32, img33];
  
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]); // Adding dependency for images.length ensures useEffect runs properly

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensure the container takes the full height of the viewport
      }}
    >
      <style>{`
        body {
          margin: 0;
          /* Prevent scrollbars */
        }
        .slideshow-container {
        
          position: relative;
          display: flex;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-color: #F0FFF0;
          flex-grow: 1; /* Allow the slideshow to grow and take available space */
        }
        .image-track {
          display: flex;
          align-items: center;
          animation: slide 400s linear infinite;
        }
        @keyframes slide {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .image-container {
          flex-shrink: 0;
          width: 70vw;
          height: 100vh;
        }
        .slideshow-image {
          position: relative;
          width: 90%;
          height: 80%;
          object-fit: cover;
          border: 10px solid white;
          box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.5);
        }
        @media screen and (max-width: 1024px) {
  .image-container {
    width: min(84vw, 900px);
    height: min(100vh, 600px);
  }
}

@media screen and (max-width: 768px) {
  .image-container {
    width: min(95vw, 700px);
    height: min(87vh, 500px);
  }
}

@media screen and (max-width: 480px) {
  .image-container {
    width: min(100vw, 400px);
    height: min(46vh, 300px);
  }
}

      `}</style>

      {/* Slideshow Section */}
      <div className="slideshow-container">
        <div className="image-track">
          {images.map((image, index) => (
            <div key={index} className="image-container">
              <img className="slideshow-image" src={image} alt={`Slide ${index + 1}`} />
            </div>
          ))}
          {images.map((image, index) => (
            <div key={`loop-${index}`} className="image-container">
              <img className="slideshow-image" src={image} alt={`Loop ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Photo;